import React, {
  useEffect,
  useRef,
  useState,
} from "react";

import {
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";

import {
  BiSolidSun,
  BiSolidMoon,
  BiLogOut,
} from "react-icons/bi";

import {
  FaUser,
  FaShoppingCart,
  FaHeart,
  FaSearch,
  FaCopy,
  FaChevronDown,
  FaTimes,
  FaChartLine,
  FaBars,
  FaChevronRight,
} from "react-icons/fa";

import axios from "axios";

import {
  useSelector,
  useDispatch,
} from "react-redux";

import AOS from "aos";
import "aos/dist/aos.css";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  useGetTodosQuery,
} from "../../redux/slices/productApiSlice";

import {
  useGetsTodosQuery,
} from "../../redux/slices/todoApiSlice";

import {
  logout,
} from "../../redux/slices/authSlice";

import {
  useLogoutMutation,
} from "../../redux/slices/usersApiSlice";


const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const desktopSearchRef = useRef(null);
  const mobileSearchRef = useRef(null);

  const [isMenuOpen, setIsMenuOpen] =
    useState(false);

  const [isProfileOpen, setIsProfileOpen] =
    useState(false);

  const [searchQuery, setSearchQuery] =
    useState("");

  const [items, setItems] = useState([]);

  const [loading, setLoading] =
    useState(false);

  const { userInfo } = useSelector(
    (state) => state.auth
  );


  /*
   * =========================================================
   * DATA
   * =========================================================
   */

  const { data: cartData } =
    useGetTodosQuery();

  const { data: favoriteData } =
    useGetsTodosQuery();

  const cartItems =
    cartData?.todos ||
    cartData?.allTodos ||
    cartData ||
    [];

  const favorites =
    favoriteData?.todos ||
    favoriteData?.allTodos ||
    favoriteData ||
    [];

  const itemCount = Array.isArray(cartItems)
    ? cartItems.length
    : 0;

  const favoriteCount = Array.isArray(
    favorites
  )
    ? favorites.length
    : 0;


  /*
   * =========================================================
   * AOS
   * =========================================================
   */

  useEffect(() => {
    AOS.init({
      duration: 350,
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);


  /*
   * =========================================================
   * MOBILE DRAWER BODY LOCK
   * =========================================================
   */

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow =
        "hidden";
      document.body.style.touchAction = "none";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow =
        "";
      document.body.style.touchAction = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow =
        "";
      document.body.style.touchAction = "";
    };
  }, [isMenuOpen]);


  /*
   * =========================================================
   * ROUTE CHANGE
   * =========================================================
   */

  useEffect(() => {
    setIsMenuOpen(false);
    setIsProfileOpen(false);
    setSearchQuery("");
    setItems([]);
    setLoading(false);
  }, [location.pathname]);


  /*
   * =========================================================
   * ESCAPE
   * =========================================================
   */

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsMenuOpen(false);
        setIsProfileOpen(false);
      }
    };

    document.addEventListener(
      "keydown",
      handleEscape
    );

    return () => {
      document.removeEventListener(
        "keydown",
        handleEscape
      );
    };
  }, []);


  /*
   * =========================================================
   * CLICK OUTSIDE SEARCH
   * =========================================================
   */

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedDesktopSearch =
        desktopSearchRef.current &&
        desktopSearchRef.current.contains(
          event.target
        );

      const clickedMobileSearch =
        mobileSearchRef.current &&
        mobileSearchRef.current.contains(
          event.target
        );

      if (
        !clickedDesktopSearch &&
        !clickedMobileSearch
      ) {
        setItems([]);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);


  /*
   * =========================================================
   * SEARCH
   * =========================================================
   */

  useEffect(() => {
    const query = searchQuery.trim();

    if (!query) {
      setItems([]);
      setLoading(false);
      return;
    }

    const delay = setTimeout(async () => {
      try {
        setLoading(true);

        const [
          qolbaqResponse,
          paginationResponse,
        ] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/qolbaq?limit=1000000`
          ),

          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/pagination/getpagenations?search=${encodeURIComponent(
              query
            )}`
          ),
        ]);

        const qolbaqResults =
          qolbaqResponse.data?.allQolbaq ||
          qolbaqResponse.data?.qolbaqlar ||
          qolbaqResponse.data?.todos ||
          qolbaqResponse.data ||
          [];

        const paginationResults =
          paginationResponse.data
            ?.allPagination ||
          paginationResponse.data
            ?.pagination ||
          paginationResponse.data?.items ||
          paginationResponse.data ||
          [];

        const normalizedQuery =
          query.toLocaleLowerCase("az-AZ");

        const filteredQolbaq =
          Array.isArray(qolbaqResults)
            ? qolbaqResults.filter((item) => {
                const searchableText = [
                  item?.name,
                  item?.title,
                  item?.description,
                  item?.catagory,
                  item?.category,
                ]
                  .filter(
                    (value) =>
                      value !== undefined &&
                      value !== null
                  )
                  .join(" ")
                  .toLocaleLowerCase(
                    "az-AZ"
                  );

                return searchableText.includes(
                  normalizedQuery
                );
              })
            : [];

        const normalizedQolbaq =
          filteredQolbaq.map((item) => ({
            ...item,
            _searchType: "qolbaq",
          }));

        const normalizedPagination =
          Array.isArray(paginationResults)
            ? paginationResults.map((item) => ({
                ...item,
                _searchType: "pagination",
              }))
            : [];

        setItems([
          ...normalizedQolbaq,
          ...normalizedPagination,
        ]);
      } catch (error) {
        console.error(
          "Axtarış xətası:",
          error
        );

        setItems([]);
      } finally {
        setLoading(false);
      }
    }, 350);

    return () => {
      clearTimeout(delay);
    };
  }, [searchQuery]);


  /*
   * =========================================================
   * LOGOUT
   * =========================================================
   */

  const [logoutApi] =
    useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutApi().unwrap();

      dispatch(logout());

      setIsProfileOpen(false);
      setIsMenuOpen(false);

      toast.success(
        "Hesabdan uğurla çıxış edildi."
      );

      navigate("/login");
    } catch (error) {
      console.error(
        "Logout error:",
        error
      );

      toast.error(
        error?.data?.message ||
          "Çıxış zamanı xəta baş verdi."
      );
    }
  };


  /*
   * =========================================================
   * REFERRAL
   * =========================================================
   */

  const referralUrl = userInfo?.referralCode
    ? `https://artim.shop/register?referral=${userInfo.referralCode}`
    : "";

  const copyReferral = async () => {
    if (!referralUrl) return;

    try {
      await navigator.clipboard.writeText(
        referralUrl
      );

      toast.success(
        "Referral link kopyalandı."
      );
    } catch (error) {
      console.error(error);

      toast.error(
        "Link kopyalana bilmədi."
      );
    }
  };


  /*
   * =========================================================
   * NAVIGATION
   * =========================================================
   */

  const navLinks = [
    {
      name: "Məhsullar",
      path: "/products",
    },
    {
      name: "Elanlar",
      path: "/pagination",
    },
    {
      name: "Haqqımızda",
      path: "/about",
    },
    {
      name: "Əlaqə",
      path: "/contact",
    },
    {
      name: "Sifarişlərim",
      path: "/confirmed",
    },
    {
      name: "Maaşlar",
      path: "/maas",
    },
    {
      name: "Maaş tarixçəsi",
      path: "/HistoryMaas",
    },
    {
      name: "Mükafatlar",
      path: "/qazanc",
    },
    {
      name: "Mükafat tarixçəsi",
      path: "/HistoryMukafat",
    },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };


  /*
   * =========================================================
   * SEARCH RESULT CLICK
   * =========================================================
   */

  const handleSearchResult = (item) => {
    const id =
      item?.qolbaq_id ||
      item?.pagination_id ||
      item?._id ||
      item?.id;

    if (!id) return;

    setSearchQuery("");
    setItems([]);
    setLoading(false);

    if (
      item?._searchType ===
      "pagination"
    ) {
      navigate(
        `/pagination/${
          item?.pagination_id ||
          item?._id ||
          item?.id
        }`
      );

      return;
    }

    navigate(`/product/${id}`);
  };


  /*
   * =========================================================
   * CLEAR SEARCH
   * =========================================================
   */

  const clearSearch = () => {
    setSearchQuery("");
    setItems([]);
    setLoading(false);
  };


  /*
   * =========================================================
   * THEME
   * =========================================================
   */

  const [darkMode, setDarkMode] =
    useState(() => {
      return document.documentElement.classList.contains(
        "dark"
      );
    });

  const toggleTheme = () => {
    const html =
      document.documentElement;

    if (html.classList.contains("dark")) {
      html.classList.remove("dark");

      localStorage.setItem(
        "theme",
        "light"
      );

      setDarkMode(false);
    } else {
      html.classList.add("dark");

      localStorage.setItem(
        "theme",
        "dark"
      );

      setDarkMode(true);
    }
  };


  /*
   * =========================================================
   * THEME INITIALIZATION
   * =========================================================
   */

  useEffect(() => {
    const savedTheme =
      localStorage.getItem("theme");

    if (savedTheme === "dark") {
      document.documentElement.classList.add(
        "dark"
      );

      setDarkMode(true);
    }

    if (savedTheme === "light") {
      document.documentElement.classList.remove(
        "dark"
      );

      setDarkMode(false);
    }
  }, []);


  /*
   * =========================================================
   * SEARCH RESULTS
   * =========================================================
   */

  const SearchResults = ({
    mobile = false,
  }) => {
    if (!searchQuery.trim()) {
      return null;
    }

    return (
      <div
        className={`
          absolute

          ${
            mobile
              ? "top-[56px]"
              : "top-[58px]"
          }

          left-0
          right-0

          overflow-hidden

          rounded-2xl

          border
          border-gray-200
          dark:border-white/10

          bg-white
          dark:bg-gray-900

          shadow-2xl
          shadow-black/20

          z-[9999]
        `}
      >
        {loading ? (
          <div className="p-5">
            <div className="flex items-center gap-3">
              <div
                className="
                  w-5
                  h-5

                  rounded-full

                  border-2
                  border-indigo-500
                  border-t-transparent

                  animate-spin
                "
              />

              <span
                className="
                  text-sm

                  text-gray-500
                  dark:text-gray-400
                "
              >
                Axtarılır...
              </span>
            </div>
          </div>
        ) : items.length > 0 ? (
          <div
            className="
              max-h-[min(420px,60dvh)]

              overflow-y-auto
              overscroll-contain

              [-webkit-overflow-scrolling:touch]
            "
          >
            {items
              .slice(0, 10)
              .map((item, index) => {
                const id =
                  item?._id ||
                  item?.qolbaq_id ||
                  item?.id ||
                  index;

                const getImageUrl = (
                  value
                ) => {
                  if (!value) return "";

                  if (
                    typeof value ===
                    "string"
                  ) {
                    return value;
                  }

                  if (
                    Array.isArray(value)
                  ) {
                    const first =
                      value.find(Boolean);

                    return getImageUrl(
                      first
                    );
                  }

                  if (
                    typeof value ===
                    "object"
                  ) {
                    return (
                      value?.url ||
                      value?.secure_url ||
                      value?.path ||
                      value?.src ||
                      value?.image ||
                      ""
                    );
                  }

                  return "";
                };

                const image =
                  getImageUrl(
                    item?.photo
                  ) ||
                  getImageUrl(
                    item?.photos
                  ) ||
                  getImageUrl(
                    item?.images
                  ) ||
                  getImageUrl(
                    item?.image
                  ) ||
                  getImageUrl(
                    item?.thumbnail
                  ) ||
                  getImageUrl(
                    item?.imageUrl
                  ) ||
                  getImageUrl(
                    item?.photoUrl
                  );

                const title =
                  item?.name ||
                  item?.title ||
                  "Məhsul";

                return (
                  <button
                    type="button"
                    key={id}
                    onClick={() =>
                      handleSearchResult(
                        item
                      )
                    }
                    className="
                      w-full

                      flex
                      items-center
                      gap-3

                      p-3

                      text-left

                      hover:bg-gray-50
                      dark:hover:bg-white/[0.05]

                      active:bg-gray-100
                      dark:active:bg-white/[0.08]

                      transition
                    "
                  >
                    <div
                      className="
                        w-12
                        h-12

                        shrink-0

                        rounded-xl

                        overflow-hidden

                        bg-gray-100
                        dark:bg-gray-800
                      "
                    >
                      {image ? (
                        <img
                          src={image}
                          alt={title}
                          className="
                            w-full
                            h-full

                            object-cover
                          "
                        />
                      ) : (
                        <div
                          className="
                            w-full
                            h-full

                            flex
                            items-center
                            justify-center

                            text-gray-400
                          "
                        >
                          <FaSearch />
                        </div>
                      )}
                    </div>

                    <div
                      className="
                        min-w-0
                        flex-1
                      "
                    >
                      <div
                        className="
                          font-semibold
                          text-sm

                          truncate

                          text-gray-900
                          dark:text-white
                        "
                      >
                        {title}
                      </div>

                      <div
                        className="
                          mt-0.5

                          text-[10px]
                          font-medium

                          text-gray-400
                          dark:text-gray-500
                        "
                      >
                        {item?._searchType ===
                        "pagination"
                          ? "Elan"
                          : "Məhsul"}
                      </div>

                      {item?.price !==
                        undefined &&
                        item?.price !== null && (
                          <div
                            className="
                              mt-0.5

                              text-xs
                              font-semibold

                              text-indigo-600
                              dark:text-indigo-400
                            "
                          >
                            {item.price} ₼
                          </div>
                        )}
                    </div>

                    <FaChevronRight
                      className="
                        text-gray-300
                        dark:text-gray-600

                        shrink-0
                      "
                      size={12}
                    />
                  </button>
                );
              })}
          </div>
        ) : (
          <div className="p-7 text-center">
            <div
              className="
                mx-auto
                mb-3

                w-12
                h-12

                rounded-2xl

                flex
                items-center
                justify-center

                bg-gray-100
                dark:bg-white/[0.06]

                text-gray-400
              "
            >
              <FaSearch />
            </div>

            <div
              className="
                font-semibold

                text-gray-800
                dark:text-white
              "
            >
              Məhsul tapılmadı
            </div>

            <div
              className="
                mt-1

                text-xs

                text-gray-400
              "
            >
              Başqa sözlə axtarmağı yoxla
            </div>
          </div>
        )}
      </div>
    );
  };


  /*
   * =========================================================
   * MOBILE MENU ITEM
   * =========================================================
   */

  const MobileMenuItem = ({
    link,
    index,
  }) => {
    const active = isActive(
      link.path
    );

    return (
      <Link
        to={link.path}
        onClick={() =>
          setIsMenuOpen(false)
        }
        className={`
          group

          flex
          items-center
          gap-3

          w-full

          py-3.5
          px-2

          border-b
          border-gray-100
          dark:border-white/[0.05]

          transition-all

          ${
            active
              ? `
                text-indigo-600
                dark:text-indigo-400
              `
              : `
                text-gray-700
                dark:text-gray-200

                hover:text-indigo-600
                dark:hover:text-indigo-400
              `
          }
        `}
      >
        <span
          className={`
            w-7
            h-7

            rounded-lg

            flex
            items-center
            justify-center

            text-[10px]
            font-bold

            shrink-0

            ${
              active
                ? `
                  bg-indigo-600
                  text-white
                `
                : `
                  bg-gray-100
                  dark:bg-white/[0.06]

                  text-gray-400
                  dark:text-gray-500
                `
            }
          `}
        >
          {String(index + 1).padStart(
            2,
            "0"
          )}
        </span>

        <span
          className="
            flex-1

            text-[14px]
            font-semibold
          "
        >
          {link.name}
        </span>

        <FaChevronRight
          size={11}
          className={`
            transition-transform

            ${
              active
                ? "text-indigo-500 translate-x-0.5"
                : "text-gray-300 dark:text-gray-600 group-hover:translate-x-0.5"
            }
          `}
        />
      </Link>
    );
  };


  /*
   * =========================================================
   * UI
   * =========================================================
   */

  return (
    <>
      {/* =====================================================
          MAIN HEADER
      ===================================================== */}

      <header
        className="
          fixed

          top-0
          left-0
          right-0

          z-50

          bg-white/90
          dark:bg-gray-950/90

          backdrop-blur-2xl

          border-b
          border-gray-200/70
          dark:border-white/[0.07]

          shadow-[0_8px_30px_rgba(0,0,0,0.04)]
          dark:shadow-[0_8px_30px_rgba(0,0,0,0.2)]
        "
      >
        <div
          className="
            w-full

            px-3
            sm:px-5
            lg:px-8
          "
        >
          {/* =================================================
              TOP ROW
          ================================================= */}

          <div
            className="
              h-[60px]
              sm:h-[68px]

              flex
              items-center

              gap-2
              sm:gap-3
            "
          >
            {/* LOGO */}

            <Link
              to="/"
              onClick={() =>
                setIsMenuOpen(false)
              }
              className="
                shrink-0

                flex
                items-center
                gap-2

                group
              "
            >
              <div
                className="
                  relative

                  w-9
                  h-9

                  sm:w-10
                  sm:h-10

                  rounded-xl

                  flex
                  items-center
                  justify-center

                  bg-gradient-to-br
                  from-indigo-600
                  via-violet-600
                  to-fuchsia-600

                  shadow-lg
                  shadow-indigo-500/20

                  group-hover:scale-105

                  transition-transform
                "
              >
                <FaChartLine
                  className="text-white"
                  size={16}
                />

                <span
                  className="
                    absolute

                    -top-1
                    -right-1

                    w-3
                    h-3

                    rounded-full

                    bg-emerald-500

                    border-2
                    border-white
                    dark:border-gray-950
                  "
                />
              </div>

              {/* =================================================
                  ARTIM SHOP TEXT
                  MOBILDA DA GÖRÜNÜR
              ================================================= */}

              <div>
                <div
                  className="
                    flex
                    items-center

                    text-[16px]
                    sm:text-xl

                    font-black
                    tracking-tight

                    whitespace-nowrap
                  "
                >
                  <span
                    className="
                      text-gray-900
                      dark:text-white
                    "
                  >
                    Artım
                  </span>

                  <span
                    className="
                      text-indigo-600
                      dark:text-indigo-400
                    "
                  >
                    Shop
                  </span>
                </div>

                <div
                  className="
                    -mt-0.5

                    text-[6px]
                    sm:text-[8px]

                    font-bold
                    uppercase
                    tracking-[0.16em]

                    text-gray-400

                    whitespace-nowrap
                  "
                >
                  Al-Sat & Qazan
                </div>
              </div>
            </Link>


            {/* DESKTOP SEARCH */}

            <div
              ref={desktopSearchRef}
              className="
                hidden
                md:block

                flex-1
                max-w-2xl
                mx-auto

                relative

                z-[60]
              "
            >
              <div
                className="
                  h-11

                  flex
                  items-center

                  rounded-2xl

                  bg-gray-100
                  dark:bg-white/[0.06]

                  border
                  border-transparent
                  dark:border-white/[0.06]

                  focus-within:bg-white
                  dark:focus-within:bg-gray-900

                  focus-within:border-indigo-500/30

                  focus-within:shadow-lg
                  focus-within:shadow-indigo-500/10

                  transition-all
                "
              >
                <FaSearch
                  className="
                    ml-4

                    text-gray-400
                    dark:text-gray-500
                  "
                  size={14}
                />

                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) =>
                    setSearchQuery(
                      e.target.value
                    )
                  }
                  placeholder="Məhsul axtar..."
                  className="
                    flex-1

                    h-full

                    px-3

                    bg-transparent

                    outline-none
                    border-none

                    text-sm

                    text-gray-900
                    dark:text-white

                    placeholder:text-gray-400
                    dark:placeholder:text-gray-500
                  "
                />

                {searchQuery && (
                  <button
                    type="button"
                    onClick={clearSearch}
                    className="
                      mr-2

                      w-8
                      h-8

                      rounded-xl

                      flex
                      items-center
                      justify-center

                      text-gray-400

                      hover:text-gray-700
                      dark:hover:text-white

                      hover:bg-gray-200
                      dark:hover:bg-white/10

                      transition
                    "
                  >
                    <FaTimes size={13} />
                  </button>
                )}
              </div>

              <SearchResults />
            </div>


            {/* RIGHT ACTIONS */}

            <div
              className="
                ml-auto

                flex
                items-center

                gap-1.5
                sm:gap-2
              "
            >
              {/* THEME */}

              <button
                type="button"
                onClick={toggleTheme}
                aria-label="Tema dəyiş"
                className="
                  w-9
                  h-9

                  sm:w-10
                  sm:h-10

                  rounded-xl

                  flex
                  items-center
                  justify-center

                  bg-gray-100
                  dark:bg-white/[0.06]

                  text-gray-600
                  dark:text-gray-300

                  hover:bg-gray-200
                  dark:hover:bg-white/10

                  transition

                  lg:flex
                "
              >
                {darkMode ? (
                  <BiSolidSun
                    size={18}
                    className="text-amber-400"
                  />
                ) : (
                  <BiSolidMoon size={18} />
                )}
              </button>


              {/* FAVORITES */}

              <Link
                to="/favorie"
                className="
                  relative

                  w-9
                  h-9

                  sm:w-10
                  sm:h-10

                  rounded-xl

                  flex
                  items-center
                  justify-center

                  bg-gray-100
                  dark:bg-white/[0.06]

                  text-gray-600
                  dark:text-gray-300

                  hover:text-rose-500

                  hover:bg-rose-50
                  dark:hover:bg-rose-500/10

                  transition
                "
              >
                <FaHeart size={15} />

                {favoriteCount > 0 && (
                  <span
                    className="
                      absolute

                      -top-1
                      -right-1

                      min-w-[17px]
                      h-[17px]

                      px-1

                      rounded-full

                      flex
                      items-center
                      justify-center

                      bg-rose-500
                      text-white

                      text-[8px]
                      font-black

                      border-2
                      border-white
                      dark:border-gray-950
                    "
                  >
                    {favoriteCount > 99
                      ? "99+"
                      : favoriteCount}
                  </span>
                )}
              </Link>


              {/* CART */}

              <Link
                to="/basket"
                className="
                  relative

                  w-9
                  h-9

                  sm:w-10
                  sm:h-10

                  rounded-xl

                  flex
                  items-center
                  justify-center

                  bg-gray-100
                  dark:bg-white/[0.06]

                  text-gray-600
                  dark:text-gray-300

                  hover:text-indigo-600
                  dark:hover:text-indigo-400

                  hover:bg-indigo-50
                  dark:hover:bg-indigo-500/10

                  transition
                "
              >
                <FaShoppingCart size={15} />

                {itemCount > 0 && (
                  <span
                    className="
                      absolute

                      -top-1
                      -right-1

                      min-w-[17px]
                      h-[17px]

                      px-1

                      rounded-full

                      flex
                      items-center
                      justify-center

                      bg-indigo-600
                      text-white

                      text-[8px]
                      font-black

                      border-2
                      border-white
                      dark:border-gray-950
                    "
                  >
                    {itemCount > 99
                      ? "99+"
                      : itemCount}
                  </span>
                )}
              </Link>


              {/* DESKTOP PROFILE */}

              <div
                className="
                  relative
                  z-[70]

                  hidden
                  lg:block
                "
              >
                {userInfo ? (
                  <>
                    <button
                      type="button"
                      onClick={() =>
                        setIsProfileOpen(
                          (prev) => !prev
                        )
                      }
                      className="
                        h-10

                        pl-1.5
                        pr-2.5

                        rounded-xl

                        flex
                        items-center
                        gap-2

                        bg-gray-100
                        dark:bg-white/[0.06]

                        hover:bg-gray-200
                        dark:hover:bg-white/10

                        transition
                      "
                    >
                      <div
                        className="
                          w-7
                          h-7

                          rounded-full

                          overflow-hidden

                          flex
                          items-center
                          justify-center

                          bg-gradient-to-br
                          from-indigo-500
                          to-violet-600

                          text-white
                        "
                      >
                        {userInfo?.photo ? (
                          <img
                            src={
                              userInfo.photo
                            }
                            alt="Profil"
                            className="
                              w-full
                              h-full

                              object-cover
                            "
                          />
                        ) : (
                          <FaUser size={12} />
                        )}
                      </div>

                      <div className="hidden xl:block">
                        <div
                          className="
                            max-w-[90px]

                            truncate

                            text-xs
                            font-bold

                            text-gray-800
                            dark:text-white
                          "
                        >
                          {userInfo?.name ||
                            userInfo?.username ||
                            "Hesabım"}
                        </div>
                      </div>

                      <FaChevronDown
                        size={9}
                        className={`
                          text-gray-400

                          transition-transform

                          ${
                            isProfileOpen
                              ? "rotate-180"
                              : ""
                          }
                        `}
                      />
                    </button>


                    {isProfileOpen && (
                      <div
                        data-aos="fade-down"
                        className="
                          absolute

                          top-[50px]
                          right-0

                          w-[310px]

                          overflow-hidden

                          rounded-3xl

                          border
                          border-gray-200
                          dark:border-white/10

                          bg-white
                          dark:bg-gray-900

                          shadow-2xl
                          shadow-black/15

                          z-[999999]
                        "
                      >
                        <div
                          className="
                            p-5

                            bg-gradient-to-br
                            from-indigo-600
                            via-violet-600
                            to-fuchsia-600

                            text-white
                          "
                        >
                          <div className="flex items-center gap-3">
                            <div
                              className="
                                w-12
                                h-12

                                rounded-2xl

                                overflow-hidden

                                flex
                                items-center
                                justify-center

                                bg-white/20

                                border
                                border-white/20
                              "
                            >
                              {userInfo?.photo ? (
                                <img
                                  src={
                                    userInfo.photo
                                  }
                                  alt="Profil"
                                  className="
                                    w-full
                                    h-full

                                    object-cover
                                  "
                                />
                              ) : (
                                <FaUser
                                  size={18}
                                />
                              )}
                            </div>

                            <div className="min-w-0">
                              <div className="font-bold truncate">
                                {userInfo?.name ||
                                  userInfo?.username ||
                                  "İstifadəçi"}
                              </div>

                              <div
                                className="
                                  mt-0.5

                                  text-xs
                                  text-white/70

                                  truncate
                                "
                              >
                                {userInfo?.email ||
                                  "Hesabınız"}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="p-2">
                          <Link
                            to="/profile"
                            onClick={() =>
                              setIsProfileOpen(
                                false
                              )
                            }
                            className="
                              flex
                              items-center
                              gap-3

                              px-3
                              py-3

                              rounded-2xl

                              text-sm
                              font-medium

                              text-gray-700
                              dark:text-gray-200

                              hover:bg-gray-100
                              dark:hover:bg-white/[0.06]

                              transition
                            "
                          >
                            <FaUser className="text-indigo-500" />

                            Profilim
                          </Link>

                          <Link
                            to="/confirmed"
                            onClick={() =>
                              setIsProfileOpen(
                                false
                              )
                            }
                            className="
                              flex
                              items-center
                              gap-3

                              px-3
                              py-3

                              rounded-2xl

                              text-sm
                              font-medium

                              text-gray-700
                              dark:text-gray-200

                              hover:bg-gray-100
                              dark:hover:bg-white/[0.06]

                              transition
                            "
                          >
                            <FaShoppingCart className="text-indigo-500" />

                            Sifarişlərim
                          </Link>

                          <Link
                            to="/pagination"
                            onClick={() =>
                              setIsProfileOpen(
                                false
                              )
                            }
                            className="
                              flex
                              items-center
                              gap-3

                              px-3
                              py-3

                              rounded-2xl

                              text-sm
                              font-medium

                              text-gray-700
                              dark:text-gray-200

                              hover:bg-gray-100
                              dark:hover:bg-white/[0.06]

                              transition
                            "
                          >
                            <FaChartLine className="text-indigo-500" />

                            Elanlar
                          </Link>
                        </div>

                        {referralUrl && (
                          <div
                            className="
                              mx-3
                              mb-3

                              p-3

                              rounded-2xl

                              bg-indigo-50
                              dark:bg-indigo-500/10

                              border
                              border-indigo-100
                              dark:border-indigo-500/20
                            "
                          >
                            <div className="flex items-center justify-between gap-2">
                              <div className="min-w-0">
                                <div
                                  className="
                                    text-[10px]

                                    uppercase
                                    tracking-wider

                                    font-bold

                                    text-indigo-500
                                  "
                                >
                                  Referral link
                                </div>

                                <div
                                  className="
                                    mt-1

                                    text-xs

                                    text-gray-500
                                    dark:text-gray-400

                                    truncate
                                  "
                                >
                                  Dostlarını dəvət et
                                </div>
                              </div>

                              <button
                                type="button"
                                onClick={
                                  copyReferral
                                }
                                className="
                                  shrink-0

                                  w-9
                                  h-9

                                  rounded-xl

                                  flex
                                  items-center
                                  justify-center

                                  bg-indigo-600
                                  text-white

                                  hover:bg-indigo-700

                                  transition
                                "
                              >
                                <FaCopy size={13} />
                              </button>
                            </div>
                          </div>
                        )}

                        <div className="p-2 pt-0">
                          <button
                            type="button"
                            onClick={
                              handleLogout
                            }
                            className="
                              w-full

                              flex
                              items-center
                              gap-3

                              px-3
                              py-3

                              rounded-2xl

                              text-sm
                              font-semibold

                              text-red-500

                              hover:bg-red-50
                              dark:hover:bg-red-500/10

                              transition
                            "
                          >
                            <BiLogOut
                              size={19}
                            />

                            Çıxış et
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="flex items-center gap-2">
                    <Link
                      to="/login"
                      className="
                        h-10
                        px-4

                        rounded-xl

                        flex
                        items-center
                        justify-center

                        text-sm
                        font-semibold

                        text-gray-700
                        dark:text-gray-200

                        bg-gray-100
                        dark:bg-white/[0.06]

                        hover:bg-gray-200
                        dark:hover:bg-white/10

                        transition
                      "
                    >
                      Giriş et
                    </Link>

                    <Link
                      to="/register"
                      className="
                        h-10
                        px-4

                        rounded-xl

                        flex
                        items-center
                        justify-center

                        text-sm
                        font-bold

                        bg-indigo-600
                        text-white

                        shadow-lg
                        shadow-indigo-500/20

                        hover:bg-indigo-700

                        transition
                      "
                    >
                      Qeydiyyat
                    </Link>
                  </div>
                )}
              </div>


              {/* MOBILE MENU BUTTON */}

              <button
                type="button"
                onClick={() =>
                  setIsMenuOpen(true)
                }
                aria-label="Menyunu aç"
                aria-expanded={
                  isMenuOpen
                }
                className="
                  lg:hidden

                  w-9
                  h-9

                  sm:w-10
                  sm:h-10

                  rounded-xl

                  flex
                  items-center
                  justify-center

                  bg-gray-100
                  dark:bg-white/[0.06]

                  text-gray-700
                  dark:text-gray-200

                  active:scale-95

                  transition
                "
              >
                <FaBars size={17} />
              </button>
            </div>
          </div>


          {/* =================================================
              MOBILE SEARCH
          ================================================= */}

          <div
            ref={mobileSearchRef}
            className="
              md:hidden

              relative

              pb-2.5

              z-[55]
            "
          >
            <div
              className="
                h-12

                rounded-2xl

                flex
                items-center

                bg-gray-100
                dark:bg-white/[0.06]

                border
                border-gray-200/50
                dark:border-white/[0.05]

                focus-within:border-indigo-500/30

                focus-within:bg-white
                dark:focus-within:bg-gray-900

                transition-all
              "
            >
              <FaSearch
                className="
                  ml-3.5

                  text-gray-400
                  dark:text-gray-500
                "
                size={14}
              />

              <input
                type="text"
                value={searchQuery}
                onChange={(e) =>
                  setSearchQuery(
                    e.target.value
                  )
                }
                placeholder="Məhsul axtar..."
                className="
                  flex-1

                  h-full

                  px-3

                  bg-transparent

                  outline-none

                  text-[13px]

                  text-gray-900
                  dark:text-white

                  placeholder:text-gray-400
                  dark:placeholder:text-gray-500
                "
              />

              {searchQuery && (
                <button
                  type="button"
                  onClick={clearSearch}
                  className="
                    mr-2

                    w-8
                    h-8

                    rounded-lg

                    flex
                    items-center
                    justify-center

                    text-gray-400

                    hover:bg-gray-200
                    dark:hover:bg-white/10
                  "
                >
                  <FaTimes size={12} />
                </button>
              )}
            </div>

            <SearchResults mobile />
          </div>
        </div>


        {/* =====================================================
            DESKTOP NAVIGATION
        ===================================================== */}

        <div
          className="
            hidden
            lg:block

            bg-white
            dark:bg-gray-950

            border-t
            border-gray-100
            dark:border-white/[0.05]

            border-b
            border-gray-100
            dark:border-white/[0.05]
          "
        >
          <div className="px-4 sm:px-6 lg:px-8">
            <nav
              className="
                min-h-11

                flex
                items-center

                gap-1

                overflow-x-auto

                scrollbar-hide
              "
            >
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`
                    relative

                    shrink-0

                    h-8

                    px-3.5

                    rounded-lg

                    flex
                    items-center
                    justify-center

                    text-xs
                    font-semibold

                    transition-all

                    ${
                      isActive(link.path)
                        ? `
                          text-indigo-600
                          dark:text-indigo-400

                          bg-indigo-50
                          dark:bg-indigo-500/10
                        `
                        : `
                          text-gray-500
                          dark:text-gray-400

                          hover:text-gray-900
                          dark:hover:text-white

                          hover:bg-gray-50
                          dark:hover:bg-white/[0.04]
                        `
                    }
                  `}
                >
                  {link.name}

                  {isActive(link.path) && (
                    <span
                      className="
                        absolute

                        bottom-0

                        left-1/2

                        -translate-x-1/2

                        w-4
                        h-0.5

                        rounded-full

                        bg-indigo-600
                        dark:bg-indigo-400
                      "
                    />
                  )}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </header>


      {/* =====================================================
          MOBILE DRAWER
      ===================================================== */}

      {isMenuOpen && (
        <div
          className="
            fixed
            inset-0

            z-[1000000]

            lg:hidden
          "
        >
          {/* BACKDROP */}

          <button
            type="button"
            aria-label="Menyunu bağla"
            onClick={() =>
              setIsMenuOpen(false)
            }
            className="
              absolute
              inset-0

              w-full
              h-full

              bg-black/45

              backdrop-blur-[3px]
            "
          />


          {/* DRAWER */}

          <aside
            className="
              absolute

              top-0
              right-0
              bottom-0

              w-[min(88vw,390px)]

              h-[100dvh]
              min-h-[100dvh]

              flex
              flex-col

              bg-white
              dark:bg-gray-950

              shadow-[-20px_0_60px_rgba(0,0,0,0.18)]

              border-l
              border-gray-200
              dark:border-white/[0.08]

              animate-[slideInRight_.25s_ease-out]
            "
          >
            {/* DRAWER HEADER */}

            <div
              className="
                shrink-0

                px-4

                pt-[calc(12px+env(safe-area-inset-top))]

                pb-3

                border-b
                border-gray-100
                dark:border-white/[0.06]
              "
            >
              <div
                className="
                  flex
                  items-center
                  justify-between
                  gap-3
                "
              >
                <Link
                  to="/"
                  onClick={() =>
                    setIsMenuOpen(false)
                  }
                  className="
                    flex
                    items-center
                    gap-2.5
                  "
                >
                  <div
                    className="
                      w-9
                      h-9

                      rounded-xl

                      flex
                      items-center
                      justify-center

                      bg-gradient-to-br
                      from-indigo-600
                      via-violet-600
                      to-fuchsia-600

                      text-white

                      shadow-lg
                      shadow-indigo-500/20
                    "
                  >
                    <FaChartLine size={15} />
                  </div>

                  <div>
                    <div
                      className="
                        flex
                        items-center

                        text-[17px]
                        font-black

                        tracking-tight

                        whitespace-nowrap
                      "
                    >
                      <span className="text-gray-900 dark:text-white">
                        Artım
                      </span>

                      <span className="text-indigo-600 dark:text-indigo-400">
                        Shop
                      </span>
                    </div>

                    <div
                      className="
                        -mt-0.5

                        text-[7px]
                        font-bold
                        uppercase
                        tracking-[0.18em]

                        text-gray-400
                      "
                    >
                      Al-Sat & Qazan
                    </div>
                  </div>
                </Link>

                <button
                  type="button"
                  onClick={() =>
                    setIsMenuOpen(false)
                  }
                  aria-label="Menyunu bağla"
                  className="
                    w-9
                    h-9

                    rounded-xl

                    flex
                    items-center
                    justify-center

                    bg-gray-100
                    dark:bg-white/[0.06]

                    text-gray-600
                    dark:text-gray-300

                    active:scale-95

                    transition
                  "
                >
                  <FaTimes size={16} />
                </button>
              </div>
            </div>


            {/* DRAWER CONTENT */}

            <div
              className="
                flex-1
                min-h-0

                overflow-y-auto

                overscroll-contain

                [-webkit-overflow-scrolling:touch]

                px-4

                py-4

                pb-[calc(28px+env(safe-area-inset-bottom))]
              "
            >
              {/* USER */}

              {userInfo ? (
                <Link
                  to="/profile"
                  onClick={() =>
                    setIsMenuOpen(false)
                  }
                  className="
                    group

                    flex
                    items-center

                    gap-3

                    pb-4

                    border-b
                    border-gray-100
                    dark:border-white/[0.06]
                  "
                >
                  <div
                    className="
                      w-11
                      h-11

                      shrink-0

                      rounded-full

                      overflow-hidden

                      flex
                      items-center
                      justify-center

                      bg-gradient-to-br
                      from-indigo-500
                      to-violet-600

                      text-white

                      ring-4
                      ring-indigo-50
                      dark:ring-indigo-500/10
                    "
                  >
                    {userInfo?.photo ? (
                      <img
                        src={
                          userInfo.photo
                        }
                        alt="Profil"
                        className="
                          w-full
                          h-full

                          object-cover
                        "
                      />
                    ) : (
                      <FaUser size={15} />
                    )}
                  </div>

                  <div className="min-w-0 flex-1">
                    <div
                      className="
                        text-[14px]
                        font-bold

                        text-gray-900
                        dark:text-white

                        truncate
                      "
                    >
                      {userInfo?.name ||
                        userInfo?.username ||
                        "Hesabım"}
                    </div>

                    <div
                      className="
                        mt-0.5

                        text-[11px]

                        text-gray-400

                        truncate
                      "
                    >
                      Profilimə keç
                    </div>
                  </div>

                  <FaChevronRight
                    size={11}
                    className="
                      text-gray-300
                      dark:text-gray-600

                      group-hover:text-indigo-500

                      transition
                    "
                  />
                </Link>
              ) : (
                <div
                  className="
                    pb-4

                    border-b
                    border-gray-100
                    dark:border-white/[0.06]
                  "
                >
                  <div
                    className="
                      text-lg
                      font-black

                      text-gray-900
                      dark:text-white
                    "
                  >
                    Xoş gəlmisiniz 👋
                  </div>

                  <div
                    className="
                      mt-1

                      text-xs

                      text-gray-400
                    "
                  >
                    Hesabınıza daxil olun
                  </div>

                  <div
                    className="
                      grid
                      grid-cols-2

                      gap-2

                      mt-3
                    "
                  >
                    <Link
                      to="/login"
                      onClick={() =>
                        setIsMenuOpen(false)
                      }
                      className="
                        h-10

                        rounded-xl

                        flex
                        items-center
                        justify-center

                        bg-gray-100
                        dark:bg-white/[0.06]

                        text-gray-700
                        dark:text-gray-200

                        text-xs
                        font-bold
                      "
                    >
                      Giriş et
                    </Link>

                    <Link
                      to="/register"
                      onClick={() =>
                        setIsMenuOpen(false)
                      }
                      className="
                        h-10

                        rounded-xl

                        flex
                        items-center
                        justify-center

                        bg-indigo-600

                        text-white

                        text-xs
                        font-bold
                      "
                    >
                      Qeydiyyat
                    </Link>
                  </div>
                </div>
              )}


              {/* QUICK ACTIONS */}

              <div
                className="
                  grid
                  grid-cols-2

                  gap-2

                  py-4

                  border-b
                  border-gray-100
                  dark:border-white/[0.06]
                "
              >
                <Link
                  to="/favorie"
                  onClick={() =>
                    setIsMenuOpen(false)
                  }
                  className="
                    h-[58px]

                    px-3

                    rounded-2xl

                    flex
                    items-center
                    gap-3

                    bg-gray-50
                    dark:bg-white/[0.04]

                    border
                    border-gray-100
                    dark:border-white/[0.06]

                    transition

                    active:scale-[0.98]
                  "
                >
                  <div
                    className="
                      w-9
                      h-9

                      rounded-xl

                      flex
                      items-center
                      justify-center

                      bg-rose-50
                      dark:bg-rose-500/10

                      text-rose-500
                    "
                  >
                    <FaHeart size={14} />
                  </div>

                  <div>
                    <div
                      className="
                        text-[10px]
                        text-gray-400
                      "
                    >
                      Favori
                    </div>

                    <div
                      className="
                        mt-0.5

                        text-sm
                        font-black

                        text-gray-900
                        dark:text-white
                      "
                    >
                      {favoriteCount}
                    </div>
                  </div>
                </Link>


                <Link
                  to="/basket"
                  onClick={() =>
                    setIsMenuOpen(false)
                  }
                  className="
                    h-[58px]

                    px-3

                    rounded-2xl

                    flex
                    items-center
                    gap-3

                    bg-gray-50
                    dark:bg-white/[0.04]

                    border
                    border-gray-100
                    dark:border-white/[0.06]

                    transition

                    active:scale-[0.98]
                  "
                >
                  <div
                    className="
                      w-9
                      h-9

                      rounded-xl

                      flex
                      items-center
                      justify-center

                      bg-indigo-50
                      dark:bg-indigo-500/10

                      text-indigo-500
                    "
                  >
                    <FaShoppingCart size={14} />
                  </div>

                  <div>
                    <div
                      className="
                        text-[10px]
                        text-gray-400
                      "
                    >
                      Səbət
                    </div>

                    <div
                      className="
                        mt-0.5

                        text-sm
                        font-black

                        text-gray-900
                        dark:text-white
                      "
                    >
                      {itemCount}
                    </div>
                  </div>
                </Link>
              </div>


              {/* NAVIGATION TITLE */}

              <div
                className="
                  pt-4
                  pb-1

                  flex
                  items-center
                  justify-between
                "
              >
                <span
                  className="
                    text-[10px]

                    uppercase
                    tracking-[0.18em]

                    font-black

                    text-gray-400
                  "
                >
                  Naviqasiya
                </span>

                <span
                  className="
                    text-[9px]

                    text-gray-300
                    dark:text-gray-600
                  "
                >
                  ARTIM
                </span>
              </div>


              {/* NAVIGATION */}

              <div>
                {navLinks.map(
                  (link, index) => (
                    <MobileMenuItem
                      key={link.path}
                      link={link}
                      index={index}
                    />
                  )
                )}
              </div>


              {/* REFERRAL */}

              {userInfo &&
                referralUrl && (
                  <div
                    className="
                      mt-4

                      rounded-2xl

                      border
                      border-indigo-100
                      dark:border-indigo-500/20

                      bg-indigo-50/70
                      dark:bg-indigo-500/[0.07]

                      p-3
                    "
                  >
                    <div
                      className="
                        flex
                        items-center
                        justify-between

                        gap-3
                      "
                    >
                      <div className="min-w-0">
                        <div
                          className="
                            text-xs
                            font-bold

                            text-indigo-700
                            dark:text-indigo-300
                          "
                        >
                          Dostunu dəvət et
                        </div>

                        <div
                          className="
                            mt-0.5

                            text-[10px]

                            text-indigo-500/70
                          "
                        >
                          Referral linkini paylaş
                        </div>
                      </div>

                      <button
                        type="button"
                        onClick={
                          copyReferral
                        }
                        className="
                          w-9
                          h-9

                          shrink-0

                          rounded-xl

                          flex
                          items-center
                          justify-center

                          bg-indigo-600

                          text-white

                          shadow-lg
                          shadow-indigo-500/20

                          active:scale-95

                          transition
                        "
                      >
                        <FaCopy size={13} />
                      </button>
                    </div>
                  </div>
                )}


              {/* THEME */}

              <button
                type="button"
                onClick={toggleTheme}
                className="
                  mt-3

                  w-full
                  h-[58px]

                  px-3

                  rounded-2xl

                  flex
                  items-center
                  justify-between

                  bg-gray-50
                  dark:bg-white/[0.04]

                  border
                  border-gray-100
                  dark:border-white/[0.06]
                "
              >
                <div
                  className="
                    flex
                    items-center
                    gap-3
                  "
                >
                  <div
                    className="
                      w-9
                      h-9

                      rounded-xl

                      flex
                      items-center
                      justify-center

                      bg-gray-200
                      dark:bg-white/10
                    "
                  >
                    {darkMode ? (
                      <BiSolidSun
                        size={17}
                        className="text-amber-400"
                      />
                    ) : (
                      <BiSolidMoon
                        size={17}
                      />
                    )}
                  </div>

                  <div className="text-left">
                    <div
                      className="
                        text-xs
                        font-bold

                        text-gray-800
                        dark:text-white
                      "
                    >
                      Görünüş
                    </div>

                    <div
                      className="
                        mt-0.5

                        text-[10px]

                        text-gray-400
                      "
                    >
                      {darkMode
                        ? "Qaranlıq rejim"
                        : "Açıq rejim"}
                    </div>
                  </div>
                </div>

                <div
                  className={`
                    relative

                    w-9
                    h-5

                    rounded-full

                    transition-colors

                    ${
                      darkMode
                        ? "bg-indigo-600"
                        : "bg-gray-300"
                    }
                  `}
                >
                  <span
                    className={`
                      absolute

                      top-0.5

                      w-4
                      h-4

                      rounded-full

                      bg-white

                      shadow-sm

                      transition-all

                      ${
                        darkMode
                          ? "left-[18px]"
                          : "left-0.5"
                      }
                    `}
                  />
                </div>
              </button>


              {/* PROFILE / ORDERS */}

              {userInfo && (
                <div
                  className="
                    mt-3

                    grid
                    grid-cols-2

                    gap-2
                  "
                >
                  <Link
                    to="/profile"
                    onClick={() =>
                      setIsMenuOpen(false)
                    }
                    className="
                      h-11

                      rounded-xl

                      flex
                      items-center
                      justify-center

                      gap-2

                      bg-gray-50
                      dark:bg-white/[0.04]

                      border
                      border-gray-100
                      dark:border-white/[0.06]

                      text-xs
                      font-semibold

                      text-gray-700
                      dark:text-gray-200
                    "
                  >
                    <FaUser
                      size={12}
                      className="text-indigo-500"
                    />

                    Profilim
                  </Link>

                  <Link
                    to="/confirmed"
                    onClick={() =>
                      setIsMenuOpen(false)
                    }
                    className="
                      h-11

                      rounded-xl

                      flex
                      items-center
                      justify-center

                      gap-2

                      bg-gray-50
                      dark:bg-white/[0.04]

                      border
                      border-gray-100
                      dark:border-white/[0.06]

                      text-xs
                      font-semibold

                      text-gray-700
                      dark:text-gray-200
                    "
                  >
                    <FaShoppingCart
                      size={12}
                      className="text-indigo-500"
                    />

                    Sifarişlər
                  </Link>
                </div>
              )}


              {/* LOGOUT */}

              {userInfo && (
                <div
                  className="
                    mt-3

                    pt-3

                    border-t
                    border-gray-100
                    dark:border-white/[0.06]
                  "
                >
                  <button
                    type="button"
                    onClick={
                      handleLogout
                    }
                    className="
                      w-full

                      h-11

                      rounded-xl

                      flex
                      items-center
                      justify-center

                      gap-2

                      text-xs
                      font-bold

                      text-red-500

                      bg-red-50
                      dark:bg-red-500/[0.07]

                      border
                      border-red-100
                      dark:border-red-500/10

                      active:scale-[0.98]

                      transition
                    "
                  >
                    <BiLogOut size={17} />

                    Hesabdan çıx
                  </button>
                </div>
              )}

              <div className="h-3 shrink-0" />
            </div>
          </aside>
        </div>
      )}


      {/* =====================================================
          DRAWER ANIMATION
      ===================================================== */}

      <style>
        {`
          @keyframes slideInRight {
            from {
              transform: translateX(100%);
              opacity: 0.7;
            }

            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </>
  );
};

export default Header;